import React from "react";
import {
  Svg,
  Line,
  Polyline,
  Polygon,
  Path,
  Rect,
  Circle,
  Ellipse,
  Text,
  Tspan,
  G,
  Stop,
  ClipPath,
  LinearGradient,
  RadialGradient,
} from "@react-pdf/renderer";

export const Nounours = ({color} : {color: string}) => {
  // @ts-ignore
  return (<Svg id="Calque_1" data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80.38 82.2">
  <G fill={color}>
    <Path d="M73.31,33.05h-14.74c2.72-2.92,4.33-6.51,4.33-10.4,0-2.1-.47-4.11-1.33-5.98,2.05-1.73,3.36-4.32,3.36-7.22,0-5.22-4.23-9.45-9.45-9.45-3.89,0-7.22,2.35-8.67,5.7-2.09-.5-4.32-.77-6.62-.77s-4.52.27-6.62.77c-1.45-3.35-4.79-5.7-8.67-5.7-5.22,0-9.45,4.23-9.45,9.45,0,2.9,1.31,5.49,3.36,7.22-.86,1.87-1.33,3.88-1.33,5.98,0,3.89,1.61,7.48,4.33,10.4H7.07c-5.07,0-7.07,5.74-7.07,8.82s1.39,8.57,7.64,8.57h12.57s-2.5,7.65,0,11.81c0,0-4.49,1.16-7.15,2.25-2.66,1.08-4.99,5.24-2.95,9.57,2.04,4.33,3.54,6.57,5.95,7.74,2.41,1.16,5.16-.33,7.9-1.66,2.74-1.33,9.65-4.82,9.65-4.82,0,0,2.7.58,6.59.58s6.58-.58,6.58-.58c0,0,6.9,3.49,9.65,4.82,2.74,1.33,5.49,2.83,7.9,1.66,2.41-1.16,3.91-3.41,5.95-7.74,2.04-4.33-.29-8.48-2.95-9.57-2.66-1.08-7.15-2.25-7.15-2.25,2.5-4.16,0-11.81,0-11.81h12.57c6.25,0,7.64-5.49,7.64-8.57s-2-8.82-7.07-8.82ZM50.38,18.9c2.4,0,4.35,1.95,4.35,4.35s-1.95,4.35-4.35,4.35-4.35-1.95-4.35-4.35,1.95-4.35,4.35-4.35ZM30.33,18.9c2.4,0,4.35,1.95,4.35,4.35s-1.95,4.35-4.35,4.35-4.35-1.95-4.35-4.35,1.95-4.35,4.35-4.35ZM34.46,31.32c0-1.66,1.34-3,3-3,.87,0,1.65.37,2.2.96.29.04.77.04,1.06,0,.55-.59,1.33-.96,2.2-.96,1.66,0,3,1.34,3,3,0,1.31-.77,2.77-2.73,3.51v1.41c0,1.66-1.34,3-3,3s-3-1.34-3-3v-1.41c-1.96-.74-2.73-2.2-2.73-3.51ZM47.99,57.32c-1.71,2.35-5.58,6.18-7.57,7.5h-.05c-1.99-1.32-5.86-5.15-7.57-7.5-1.71-2.35-1.16-6.86,3.2-6.86s4.37,2.93,4.37,2.93h.05s.02-2.93,4.37-2.93,4.91,4.52,3.2,6.86Z"/>
  </G>
</Svg>
);
};

export default Nounours;
